/*
 * Project: bellcloud
 * File: packages/types/device/lite/protocol_fn_information.ts
 * Author: SWAN
 * Created: 2025-07-08 11:43:07
 * Description: ClassID.MORNITORING (0x01)에 대한 FunctionID별 파라미터 정의
 */
import type { FunctionParameter } from '../fns';

export const params_monitoring: Record<number, FunctionParameter[]> = {
  // FunctionID 0x02: Full monitoring response
  0x02: [
    {
      name: 'system_status',
      type: 'u16',
      bytes: 2,
      comment: 'System status',
      format: 'enum_system_status',
    },
    {
      name: 'sensor_status',
      type: 'au16[]',
      bytes: 10,
      comment: 'Sensor status array (5x2 bytes)',
      format: 'enum_array_sensor_status',
    },
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'temperature',
      type: 's16',
      bytes: 2,
      comment: 'Temperature x10 degC',
      format: 'temperature',
    },
    {
      name: 'gas_conc',
      type: 'as32[]',
      bytes: 20,
      comment: 'Gas concentration x1000 (5 channels)',
      format: 'array_conc',
    },
    {
      name: 'error_code',
      type: 'au8[]',
      bytes: 6,
      comment: 'Error code per channel (0~4 sensor, 5 system)',
      format: 'enum_array_error',
    },
    {
      name: 'warning_code',
      type: 'au8[]',
      bytes: 6,
      comment: 'Warning code per channel (0~4 sensor, 5 system)',
      format: 'enum_array_warning',
    },
    {
      name: 'sensor_type',
      type: 'au8[]',
      bytes: 5,
      comment: 'Sensor type per channel',
      format: 'enum_array_sensors',
    },
    {
      name: 'conc_unit',
      type: 'au8[]',
      bytes: 5,
      comment: 'Gas concentration unit: 0:PPM, 1:%VOL, 2:%LEL',
      format: 'enum_array_gas_conc_unit',
    },
    {
      name: 'battery_state',
      type: 'u8',
      bytes: 1,
      comment: 'Battery state: 0=Low battery, 1=5% 미만, 2=5~25%, 3=25~50%, 4=50~75%, 5=75%~100%',
    },
  ],

  // FunctionID 0x03: BLE Push (compact version)
  0x03: [
    {
      name: 'system_status',
      type: 'u16',
      bytes: 2,
      comment: 'System status',
      format: 'enum_system_status',
    },
    {
      name: 'sensor_status',
      type: 'au16[]',
      bytes: 10,
      comment: 'Sensor status array (5x2 bytes)',
      format: 'enum_array_sensor_status',
    },
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'temperature',
      type: 's16',
      bytes: 2,
      comment: 'Temperature x10 degC',
      format: 'temperature',
    },
    {
      name: 'gas_conc',
      type: 'as32[]',
      bytes: 20,
      comment: 'Gas concentration x1000 (5 channels)',
      format: 'array_conc',
    },
    {
      name: 'error_code',
      type: 'au8[]',
      bytes: 6,
      comment: 'Error code per channel (0~4 sensor, 5 system)',
      format: 'enum_array_error',
    },
    {
      name: 'warning_code',
      type: 'au8[]',
      bytes: 6,
      comment: 'Warning code per channel (0~4 sensor, 5 system)',
      format: 'enum_array_warning',
    },
    {
      name: 'sensor_type',
      type: 'au8[]',
      bytes: 5,
      comment: 'Sensor type per channel',
      format: 'enum_array_sensors',
    },
    {
      name: 'conc_unit',
      type: 'au8[]',
      bytes: 5,
      comment: 'Gas concentration unit: 0:PPM, 1:%VOL, 2:%LEL',
      format: 'enum_array_gas_conc_unit',
    },
    {
      name: 'battery_state',
      type: 'u8',
      bytes: 1,
      comment: 'Battery state: 0=Low battery, 1=5% 미만, 2=5~25%, 3=25~50%, 4=50~75%, 5=75%~100%',
    },
  ],
};
